'use client';

/**
 * In-app alternative for the subscribe picker. Rendered by
 * `SubscribeDialog` when `useIsAppUser()` is true — the CommentSold
 * native app can't run subscribe payments (App Store IAP compliance),
 * so we replace the tier picker with a short alert pointing the
 * viewer at the web.
 *
 * 1:1 port of legacy PopshopRN
 * `flows/bio/pages/access-restriction/components/AccessRestrictionAppContent.tsx`
 * — same copy ("Alert!" / "Please subscribe on the web app"), same
 * single "OK" button that dismisses the dialog.
 */
export function SubscribeInAppAlert({ onClose }: { onClose: () => void }) {
  return (
    <div className="bg-surface-2 text-content-1 flex flex-col items-center gap-6 rounded-2xl p-6 text-center">
      <div className="flex flex-col items-center gap-2">
        <h2 className="text-[32px] font-bold leading-tight">Alert!</h2>
        <p className="text-[16px] leading-snug">
          Please subscribe on the web app
        </p>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="bg-brand text-content-on-brand w-full rounded-lg py-3 text-[16px] font-semibold transition hover:opacity-90"
      >
        OK
      </button>
    </div>
  );
}
